/**
 * Resolve the API base URL.
 *
 * Production / Preview: ALWAYS same-origin (window.location.origin) — Emergent
 *   ingress routes /api/* to the backend. This avoids cross-origin CORS issues
 *   with credentialed cookies (Access-Control-Allow-Origin must echo a specific
 *   origin, not '*', when allow-credentials is true; some CDNs override with '*').
 *
 * Local dev: if running on localhost (yarn start) AND a REACT_APP_BACKEND_URL
 *   is provided, use that (the local backend usually runs on :8001).
 */
export const getApiBase = () => {
  if (typeof window === "undefined") {
    return process.env.REACT_APP_BACKEND_URL || "";
  }
  const origin = window.location.origin;
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (/(^|\/\/)localhost(:|$)/.test(origin) && envUrl) {
    return envUrl;
  }
  return origin;
};

export const API_BASE = getApiBase();
